import { useCallback } from 'react';

import { useDispatch } from 'react-redux';
import { actionCreators } from '@cube3/state/src/redux/ducks/resource-edges/actions';
import { actionCreators as requestActionCreators } from '@cube3/state/src/redux/ducks/request-status';
import {
  useSelection,
  useSelectionActions
} from '@cube3/state/src/redux/components/useSelection';
import { useFavoriteActions } from '../../../../Favorited/hooks/useFavoriteActions';
import { useDeleteActions } from '@cube3/state/src/redux/components/Hooks/useDeleteActions';
import { DraggableItem, DropTarget } from './Draggable';
import { ResourceIdentifier } from '@cube3/state/types';

export const useDropHandler = () => {
  const { visiting } = useSelection();
  const { clearItems, clearActiveItem } = useSelectionActions();

  const { onAddToFavorites } = useFavoriteActions(clearItems, clearActiveItem);
  const { deleteResources } = useDeleteActions();

  const dispatch = useDispatch();

  const onUploadFile = useCallback(
    (draggedItems: DraggableItem[], dropTargetId: string, sourceFolder: ResourceIdentifier) => {
      if (!draggedItems || !dropTargetId) return;
      dispatch(
        actionCreators.uglyMoveItems(draggedItems, {
          type: 'folder',
          id: dropTargetId
        }, sourceFolder)
      );
      if (visiting) {
        dispatch(
          requestActionCreators.invalidateRelationship({
            relationship: 'assets',
            id: visiting.id,
            type: 'folder'
          })
        );
      }
      clearItems();
      clearActiveItem();
    },
    [visiting, dispatch, clearItems, clearActiveItem]
  );

  const handleDrop = useCallback(
    (draggedItems: DraggableItem[], dropTarget: DropTarget, sourceFolder: ResourceIdentifier) => {
      console.info('>>drop', {
        visiting,
        parent: draggedItems?.[0]?.parent,
        dropTarget,
        sourceFolder
      });
      switch (!!draggedItems?.length && !!dropTarget) {
        case ['folder', 'project'].includes(dropTarget.type) &&
          // prevent files from being dropped into the current folder
          draggedItems[0].parent !== dropTarget.id:
          onUploadFile(draggedItems, dropTarget.id, sourceFolder);
          break;
        case dropTarget.id === 'favorites':
          onAddToFavorites(draggedItems);
          break;
        case dropTarget.id === 'trash':
        case dropTarget.id === 'bin':
          deleteResources(draggedItems);
          break;
        default:
          break;
      }
    },
    [deleteResources, onUploadFile, onAddToFavorites]
  );

  return handleDrop;
};
